<template>
  <div>
    <div class="row mb-5">
      <div class="col-12">
        <DeviceMseesageFilters
          :filters="localFilters"
          :devices="devices"
          @update:filters="applyFilters"
        />
      </div>
      <div class="col-12">
        <DashboardCard
          title="Messages"
          icon="bi-journal-text"
          section="messagesSection"
          :isLoading="['messages', 'all'].includes(isLoading)"
          :isLarge="true"
          @refresh="refreshData('messages')"
          :fullHeight="true"
          :withControls="false"
        >
          <template #content>
            <MessageList
              :data="messagesData"
              :isLoading="['messages', 'all'].includes(isLoading)"
              @delete="confirmDelete"
            />
          </template>
        </DashboardCard>
      </div>

      <div class="col-12 mt-n2 mb-3">
        <PaginationComponent
          v-if="pagination"
          :pagination="pagination"
          @change="handlePageChange"
        />
      </div>

      <BootstrapModal
        ref="deleteConfirmModal"
        modalId="deleteMessageModal"
        title="Confirm Delete"
        confirmText="Delete"
        @confirm="deleteMessage"
      >
        <template #body>
          Are you sure you want to delete this message?
        </template>
      </BootstrapModal>
    </div>
  </div>
</template>
  
  <script>
import DeviceMseesageFilters from "@/components/Device/DeviceMseesageFilters.vue";
import DashboardCard from "@/components/Common/DashboardCard.vue";
import MessageList from "@/components/Common/MessageList.vue";
import MessageService from "@/services/messageService.js";
import PaginationComponent from "@/components/Common/Pagination.vue";
import BootstrapModal from "@/components/Common/BootstrapModal.vue";
import emitter from "@/eventBus";

export default {
  components: {
    DashboardCard,
    DeviceMseesageFilters,
    MessageList,
    PaginationComponent,
    BootstrapModal,
  },
  data() {
    const today = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(today.getDate() - 7);

    const formatDate = (date) => date.toISOString().split("T")[0];

    return {
      isLoading: false,
      messagesData: null,
      localFilters: {
        startDate: formatDate(oneWeekAgo),
        endDate: formatDate(today),
        type: "",
        deviceId: "",
        sort: "id|desc",
        page: 1,
      },
      devices: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
      },
      messageToDelete: null,
    };
  },
  mounted() {
    this.refreshData("messages");
  },
  methods: {
    async refreshData(type) {
      this.isLoading = type;

      try {
        const data = await MessageService.getMessages(this.localFilters);
        this.messagesData = data.messages;
        this.devices = data.devices;
        this.pagination = data.meta;
      } catch (error) {
        console.error(`Error fetching ${type} data:`, error);
      } finally {
        this.isLoading = false;
      }
    },
    applyFilters(filters) {
      this.localFilters = { ...filters, page: 1 };
      this.refreshData("messages");
    },
    handlePageChange(page) {
      const pageNum = Number(page);
      if (
        !Number.isInteger(pageNum) ||
        pageNum < 1 ||
        pageNum > this.pagination.last_page ||
        pageNum === this.pagination.current_page
      ) {
        return;
      }

      this.localFilters.page = pageNum;
      this.refreshData("messages");
    },
    confirmDelete(msg) {
      this.messageToDelete = msg;
      this.$refs.deleteConfirmModal.show();
    },
    async deleteMessage() {
      try {
        if (!this.messageToDelete || !this.messageToDelete.id) return;
        const success = await MessageService.deleteMessage(this.messageToDelete.id);
        if (success) {
            this.$refs.deleteConfirmModal.hide();

            emitter.emit("show-toast", {
                message: `Message deleted successfully.`,
                type: "success",
            });
        }
        this.refreshData("messages");
        this.messageToDelete = null;
      } catch (error) {
        console.error("Failed to delete message:", error);
      }
    },
  },
};
</script>